import { StyleController } from '../../../common/dom/_CssProperty';

/**
 * // Class Obj: モーダルウィンドウに付属するパーツ（オーバーレイ等）を管理
 * // Note:
 * // - オーバーレイの生成・表示切替を担当します。
 * // - body のスクロール制御もここに集約します。
 */
export class ModalAttachment
{
  private readonly mStyleController: StyleController;
  private readonly mSiteBody: HTMLElement;
  public readonly mOverlay: HTMLElement;

  constructor(site_body: HTMLElement)
  {
    this.mStyleController = new StyleController();
    this.mSiteBody = site_body;

    this.mOverlay = this.ensureOverlay();
  }

  /**
   * // Method: オーバーレイ要素を取得、なければ生成する
   */
  private ensureOverlay(): HTMLElement
  {
    let overlay = document.getElementById('modalOverlay') as HTMLElement | null;

    if (!overlay)
    {
      overlay = document.createElement('div');
      overlay.id = 'modalOverlay';
      overlay.setAttribute('aria-hidden', 'true');
      overlay.style.display = 'none';

      document.body.appendChild(overlay);
    }

    return overlay;
  }

  /**
   * // Method: オーバーレイの表示状態を切り替える
   */
  public toggleOverlay(show: boolean): void
  {
    this.mStyleController.applyDisplayToElement(this.mOverlay.style, show ? 'block' : 'none');
    this.mOverlay.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  /**
   * // Method: body のスクロール可否を切り替える
   */
  public toggleScrollBody(enable: boolean): void
  {
    this.mSiteBody.toggleAttribute('data-modal-scroll-locked', !enable);
  }
}
